// src/components/common/Logo.jsx
//
// The official Best in Brands lockups. Three shapes — the horizontal wordmark,
// the vertical wordmark and the mark on its own — each supplied in black and
// white by the brand team.
//
// The artwork is fixed: never recolour it, never squash it, never rebuild it in
// CSS. The only decision this component makes is which of the two colourways
// the current theme needs, which is why it reads the theme rather than taking a
// prop — one import, right in both themes, the same deal as the colour tokens.
//
// Sizing: pass a height (`h-6`, `h-[88px]`). The width follows.

import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { cx } from './ui';
import horizontalBlack from '../../assets/brand/wordmark-horizontal-black.png';
import horizontalWhite from '../../assets/brand/wordmark-horizontal-white.png';
import verticalBlack from '../../assets/brand/wordmark-vertical-black.png';
import verticalWhite from '../../assets/brand/wordmark-vertical-white.png';
import markBlack from '../../assets/brand/mark-black.png';
import markWhite from '../../assets/brand/mark-white.png';

const LOCKUPS = {
  horizontal: { black: horizontalBlack, white: horizontalWhite },
  vertical: { black: verticalBlack, white: verticalWhite },
  mark: { black: markBlack, white: markWhite },
};

const Logo = ({ variant = 'horizontal', className, alt = 'Best in Brands' }) => {
  const { isDark } = useTheme();

  return (
    <img
      src={LOCKUPS[variant][isDark ? 'white' : 'black']}
      alt={alt}
      draggable={false}
      className={cx('block w-auto select-none', className)}
    />
  );
};

export default Logo;
